import * as React from "react";

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  fill?: string;
  checkColor?: string;
  size?: number | string;
}

export const LogoClock = ({
  className = undefined,
  style,
  fill = "white",
  size = "100%",
}: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ width: size, height: size, ...style }}
    width="429"
    height="429"
    viewBox="0 0 429 429"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M214.2,0 C332.499,0 428.4,95.901 428.4,214.2 C428.4,332.499 332.499,428.399 214.2,428.399 C95.9,428.399 0,332.499 0,214.2 C0,95.901 95.9,0 214.2,0 Z M214.056,388.237 C310.174,388.237 388.094,310.317 388.094,214.2 C388.094,118.081 310.174,40.162 214.056,40.162 C117.938,40.162 40.018,118.081 40.018,214.2 C40.018,310.317 117.938,388.237 214.056,388.237 Z M209.1473,206.1897 L297.6983,120.8167 L318.5873,141.7067 L210.8473,268.3257 L145.0453,196.7677 L165.9353,175.8777 L209.1473,206.1897 Z"
        id="logo_clockwise-clock"
        fill={fill}
      />
    </g>
  </svg>
);
